import CheckCircleIcon from "@svg/new-design/check-circle";
import CheckCircleBgIcon from "@svg/new-design/check-circle-bg";
import { keyLearningItem } from "@types";
import { FC } from "react";

interface Props {
  keyLearningData: keyLearningItem[];
}
const KeyLearning: FC<Props> = ({ keyLearningData }) => {
  if (!Array.isArray(keyLearningData)) return null;
  return (
    <div className="md:pt-2  md:pb-8    py-6">
      <p className="md:headline-md headline-sm     md:mb-3 mb-4">
        در این آموزش می‌آموزید:
      </p>
      <div className="flex flex-col gap-y-2">
        {keyLearningData.map((KeyLearning, index) => (
          <div
            key={index}
            className="flex  md:items-center items-start gap-x-1  "
          >
            <CheckCircleBgIcon className="shrink-0 w-fds-22 h-fds-22 md:w-7 md:h-7 text-fds-icon-tertiary" />
            <p className="md:body-md body-sm text-fds-primary">
              {KeyLearning.objective}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default KeyLearning;
